import React from 'react';

import env from '../../env';
import Page from '../hocs/Page';

export default Page(function Dashboard (props) {
  return (
    <div className="dashboard container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>ダッシュボード</h4>
        </div>
        <div>
          {
            ({
              1: (
                <div className="alert alert-info">
                  【営業日時】
                  <br />
                  平日・祝日：9時〜17時
                  <br />
                  <div className="text-danger">
                    ※土曜日・日曜日は完全定休日
                    <br />
                    ※祝日は「toB」(FBA納品等)出荷は対応致しておりません。
                  </div>
                  <div className="mt-3">
                  個人宅宛配送：当日12時までの依頼で当日出荷
                    <br />
                  toB出荷：前日までの依頼で翌営業日出荷
                  </div>
                </div>
              ),
              5: (
                <div className="alert alert-info">
                  【営業日時】
                  <br />
                  入出荷時間：9時〜17時
                  <div className="text-danger">
                    ※土曜日・日曜日・祝日は完全定休日
                  </div>
                </div>
              ),
            })[(env('NUMBER') || '1')] ?? (
              <div className="alert alert-info">
                【営業日時】
                <br />
                入出荷時間：9時〜17時
                <br />
                平日・祝日は通常通り稼働
                <br />
                <div className="text-danger">
                  ※土曜日・日曜日は完全定休日
                  <br />
                  ※祝日は通常通り稼働しています。
                </div>
              </div>
            )
          }
        </div>
        <div className="text-muted">
          No Contents
        </div>
      </div>
    </div>
  );
});
